import { IServiceFeeConfig } from '@modeso/types__dgoods-products';
import { ProductType } from '../enums/productType.enum';

export interface ProductSettingsList {
    whiteListed: boolean;
    productLineName: string;
    type: ProductType;
    couponsEnabled: boolean;
    displayOnIOS: boolean;
    displayOnAndroid: boolean;
    isGreyedOut: boolean;
    serviceFee: boolean;
    serviceFeeConfig?: IServiceFeeConfig;
}
